// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var Application = /** @class */ (function () {
    function Application() {
    }
    return Application;
}());
export { Application };
//# sourceMappingURL=Application.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-properties-js/dist-esm/Context/Application.js
// module id = 604
// module chunks = 42